import React, { Component } from 'react';
import { PageHeader, Alert } from "react-bootstrap";
import DemographicInfoStatic from "./DemographicInfoStatic";
import EducationInfoStatic from "./EducationInfoStatic";
import OtherInfoStatic from "./OtherInfoStatic";

class Application extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {
    if(this.props.applicationSet && !this.props.application.complete)
      this.props.history.push('/');
  }

  render() {
    const {
      ethnicity,
      deltaId,
      phones,
      address,
      name,
      gender,
      email,
      dateOfBirth,
      maritalStatus,
      hsName,
      hsGpa,
      hsDiploma,
      hsGed,
      hsForeignDiploma,
      colleges,
      collegeUnits,
      collegeMajor,
      collegeGrad,
      degrees,
      edGoalDegree,
      edGoalCertificate,
      edGoalTransfer,
      sjdcEops,
      otherEops,
      sjdcDsps,
      motherEdLevel,
      fatherEdLevel,
      motherLanguage,
      fatherLanguage,
      fosterYouth,
      veteran,
      headOfHousehold,
      ab540,
      cashAid,
      calworks,
      dependents,
      termApplying
    } = this.props.application;
    const demographicInfo = {
      studentEthnicity: ethnicity,
      deltaId,
      gender,
      phones,
      address,
      name,
      email,
      dateOfBirth,
      maritalStatus
    };
    const educationInfo = {
      hsName,
      hsGpa,
      hsDiploma,
      hsGed,
      hsForeignDiploma,
      colleges,
      collegeMajor,
      collegeUnits,
      edGoalDegree,
      edGoalCertificate,
      edGoalTransfer,
      collegeGrad,
      degrees
    };
    const otherInfo = {
      sjdcEops,
      otherEops,
      sjdcDsps,
      motherEdLevel,
      fatherEdLevel,
      motherLanguage,
      fatherLanguage,
      fosterYouth,
      veteran,
      headOfHousehold,
      ab540,
      cashAid,
      calworks,
      dependents
    };

    return (
      <div className="container">
        <PageHeader>
          Application For Services <small>{termApplying}</small>
        </PageHeader>
        <Alert bsStyle="warning">An application has already been submitted for this term. This page is read-only.</Alert>
        <DemographicInfoStatic {...demographicInfo} />
        <EducationInfoStatic {...educationInfo} />
        <OtherInfoStatic {...otherInfo} />
      </div>
    )
  }
}

export default Application;